import React from 'react';
import { LoadingButton } from '@mui/lab';
import './SyncErrorTooltipContent.scss';
import { useTranslation } from 'react-i18next';

interface SyncErrorTooltipContentProps {
  disabled?: boolean;
  email?: string;
  onReconnect: () => void;
  onDisconnect?: () => void;
  isDisconnecting?: boolean;
  isConnecting?: boolean;
}

const SyncErrorTooltipContent: React.FC<SyncErrorTooltipContentProps> = ({
  disabled = false,
  email,
  onReconnect,
  onDisconnect,
  isDisconnecting,
  isConnecting,
}) => {
  const { t } = useTranslation();
  return (
    <div className="sync-error-tooltip-content">
      <div className="sync-error-tooltip-content__title">
        {t('calendar.sidebar.syncErrorTitle')}
      </div>
      <div className="sync-error-tooltip-content__description">
        {email
          ? t('calendar.sidebar.authorizeEmailAgain', { email })
          : t('calendar.sidebar.authorizeAgain')}
      </div>
      <LoadingButton
        variant="outlined"
        onClick={onReconnect}
        disabled={disabled}
        className="sync-error-tooltip-content__button"
        loading={isConnecting}
      >
        {t('calendar.sidebar.reconnect')}
      </LoadingButton>
      {onDisconnect && (
        <LoadingButton
          variant="outlined"
          onClick={onDisconnect}
          disabled={disabled}
          className="sync-error-tooltip-content__button"
          loading={isDisconnecting}
        >
          {t('calendar.sidebar.disconnect')}
        </LoadingButton>
      )}
    </div>
  );
};

export default SyncErrorTooltipContent;
